import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { basePaymentMethodModel } from "@/feature-wallet/models/any-payment-method.mjs";

export const paypalPaymentMethodModel = {
  ...basePaymentMethodModel,

  providerType: "BRAINTREE" as const,
  type: "paypal_account" as const,
} satisfies ModelDefinition;

export interface PayPalPaymentMethod
  extends FromModel<typeof paypalPaymentMethodModel> {}
